export const fontFamilys = {
  poppinsFont: 'Poppins'
};
